<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import ConfettiGenerator from 'confetti-js'

import type { ContestColor, ContestGameReward, GameContest } from '@/types'

defineEmits<{
  (e: 'onCompleted'): void
}>()
const props = withDefaults(
  defineProps<{
    modelValue: boolean
    contestGame: GameContest
    contestColor: ContestColor
    contestReward: ContestGameReward
    webAppUrl?: string
  }>(),
  {
    webAppUrl: '',
  },
)

const animation = ref<ConfettiGenerator | null>(null)
const hexToRgb = (hex: string): number[] => {
  const r = `0x${hex[1]}${hex[2]}`
  const g = `0x${hex[3]}${hex[4]}`
  const b = `0x${hex[5]}${hex[6]}`

  return [+r, +g, +b]
}

const colors = [
  hexToRgb(props.contestColor.backgroundColor),
  hexToRgb(props.contestColor.buttonColor),
  hexToRgb(props.contestColor.textColor),
]

const setAnimation = async () => {
  const windowWidth = window.innerWidth < 380 ? 396 : window.innerWidth
  const windowHeight = window.innerHeight < 350 ? 704 : window.innerHeight

  return await new ConfettiGenerator({
    target: 'animation',
    max: '450',
    size: '1.3',
    animate: true,
    props: ['circle', 'square'],
    colors,
    clock: '50',
    rotate: true,
    width: windowWidth,
    height: windowHeight,
    start_from_edge: false,
    respawn: true,
  })
}

onMounted(async () => {
  animation.value = await setAnimation()
})

const render = async () => {
  document.body.style.overflow = 'hidden'

  await animation.value.render()
}

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue) render()
  },
)
</script>

<template>
  <canvas id="animation" class="fixed left-0 right-0 top-0 h-full w-full" />
</template>
